import { render, staticRenderFns } from "./BatchWaitBillList.vue?vue&type=template&id=5a65802a&scoped=true"
import script from "./BatchWaitBillList.vue?vue&type=script&lang=js"
export * from "./BatchWaitBillList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65802a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a65802a')) {
      api.createRecord('5a65802a', component.options)
    } else {
      api.reload('5a65802a', component.options)
    }
    module.hot.accept("./BatchWaitBillList.vue?vue&type=template&id=5a65802a&scoped=true", function () {
      api.rerender('5a65802a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/dialog/BatchWaitBillList.vue"
export default component.exports